import { FC } from "react";
import { useIntl } from "react-intl";

import { FilterAutocompleteInput } from "../filter-autocomplete";

export enum TrainType {
  CUSTOM = "CUSTOM",
  SYSTEM = "SYSTEM",
}

export const TrainTypeInput: FC = () => {
  const { formatMessage } = useIntl();

  const systemOptions = [1, 2, 3, 4, 5].map(id => ({
    id: `system_${id}`,
    group: TrainType.SYSTEM,
    title: formatMessage({ id: `enums.trainSystemType.${id}` }),
  }));

  return (
    <FilterAutocompleteInput
      systemOptions={systemOptions}
      name="trainType"
      controller="train-type"
      variant="outlined"
      isGrouped
      groupName="CUSTOM"
    />
  );
};
